import { apiClientManager } from '@common/api';
export default async function getToolboxInfo() {
    return apiClientManager
        .getClient()
        .get('/api/toolbox')
        .then((r) => r.data);
}
